<template>
    <div>
        <NavBar></NavBar>
        <h3 class="my-3 mx-auto">Tubo metálico en formato completo</h3>
        <p>En este apartado prodrá cotizar unicamente formatos completos de tubería metálica, sin incluir ningún
            tipo de
            servicio.</p>
        <CompSectionTube @sendKiloPrice="getKiloPrice" @sendWeigthMeter="getWeigth" @sendLength="getDimensions">
        </CompSectionTube>
        <PriceCompSection :getKiloPrice="kiloPrice" :getWeightMeter="weigth" :getLengthValue="length">
        </PriceCompSection>
    </div>
</template>
<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue";
import CompSectionTube from "@/components/CompleteSectionQuote/CompSectionTubeComponent.vue";
import PriceCompSection from "@/components/CompleteSectionQuote/CompSectionPricePerfTubComponent.vue";
export default {
    name: "CompleteSectionView",
    data() {
        return {
            kiloPrice: 0,
            weigth: 0,
            length: 0,
        };
    },
    methods: {
        getKiloPrice(data) {
            this.kiloPrice = data;
            // console.log("Desde el padre kiloPrice", this.kiloPrice);
        },
        getWeigth(data) {
            this.weigth = data;
            // console.log("Desde el padre weigth", this.weigth);
        },
        getDimensions(data) {
            this.length = data;
            // console.log("Desdde el padre length", this.length);
        }
    },
    components: {
        NavBar,
        CompSectionTube,
        PriceCompSection,
    },
};
</script>